import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './lib/amplify';
import { serviceWorkerManager } from './utils/serviceWorker';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register service worker for offline functionality
if (import.meta.env.PROD) {
  serviceWorkerManager.register({
    onSuccess: () => {
      console.log('App is ready for offline use');
    },
    onUpdate: () => {
      console.log('New content is available; please refresh');
    },
    onError: (error) => {
      console.error('Error during service worker registration:', error);
    },
  });
}
